import { AddRounded, ContactsOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingFallback from "../../../../../components/LoadingFallback";
import TitledCard from "../../../../../components/ui/TitledCard";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../../../redux/actions/sidebarActions";
import LoanRelatedContactCardsRenderer from "../../../../../components/common/Loan/LoanRelatedContactCardsRenderer";

const SummaryLoanRelatedContactsCard = ({ sx }) => {
  // This function is called when user clicks "Save" in the row
  const dispatch = useDispatch();

  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  return (
    <TitledCard
      title={"Loan Related Contacts"}
      icon={<ContactsOutlined className="thin" />}
      variant="h3"
      headerEndContent={
        <Tooltip title="Add Contact To Loan" disableInteractive>
          <IconButton
            size="small"
            onClick={() =>
              dispatch(
                sidebarTypeToggle(
                  loanDrilldownSidebarTypes.ADD_LOAN_RELATED_CONTACT
                )
              )
            }
            sx={{ position: "absolute", right: 16, top: 16 }}
          >
            <AddRounded className="thin" />
          </IconButton>
        </Tooltip>
      }
      sx={sx}
    >
      <>
        <Suspense fallback={<LoadingFallback />}>
          <LoanRelatedContactCardsRenderer
            loanRelatedContacts={loanDrilldown?.loanRelatedContacts}
          />
        </Suspense>
      </>
    </TitledCard>
  );
};

export default SummaryLoanRelatedContactsCard;
